import { useEffect, useState } from "react";
import { ICreateSalesData } from "../../@types";

export const useInvoiceCalculations = (
  formData: ICreateSalesData,
  isRetail: boolean,
  serviceType?: string,
) => {
  const [subTotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [calcTax, setCalcTax] = useState(0);
  const [calcDiscount, setCalcDiscount] = useState(0);
  const [calcShipping, setCalcShipping] = useState(0);

  useEffect(() => {
    let calculatedSubTotal = 0;
    if (isRetail && formData.inventories && !formData.lineItems) {
      for (let inventory of formData?.inventories) {
        if (inventory.variations && inventory.variations.length > 0) {
          for (let variation of inventory.variations) {
            calculatedSubTotal += variation.quantity * variation.price;
          }
        } else {
          calculatedSubTotal +=
            (inventory.rate || 0) * (inventory.quantity || 0);
        }
      }
    } else if (!isRetail && formData.services && !formData.lineItems) {
      for (let service of formData?.services) {
        if (service.price && typeof service.price == "object") {
          for (let price of service.price) {
            if (service?.serviceType == "time-based") {
              calculatedSubTotal += price.amount * +service.duration;
            } else {
              calculatedSubTotal += +price.amount;
            }
            calculatedSubTotal += price.amount;
          }
        } else {
          if (typeof service.duration === "number") {
            calculatedSubTotal +=
              (+service.price || 0) * (service.duration || 0);
          } else {
            calculatedSubTotal += +service.price || 0;
          }
        }
      }
    } else if (!isRetail && formData.services && formData.lineItems) {
      for (let services of formData?.services) {
        if (services.price && typeof services.price == "object") {
          for (let price of services.price) {
            if (serviceType == "time-based") {
              calculatedSubTotal += price.amount * +services.duration;
            } else {
              calculatedSubTotal += +price.amount;
            }
          }
        } else {
          if (serviceType == "time-based") {
            calculatedSubTotal +=
              (services.price || 0) * (services.duration || 0);
          } else {
            calculatedSubTotal += services.price || 0;
          }
        }
      }
    } else if (formData.inventories) {
      for (const item of formData.inventories) {
        calculatedSubTotal += (item.rate || 0) * (item.quantity || 0);
      }
    }

    // Add shipping charge to subtotal
    let shippingCharge = Number(formData.shippingCharge || 0);
    let discountAmount = calculatedSubTotal * ((formData.discount || 0) / 100);
    let updatedCalculatedSubTotal = calculatedSubTotal - discountAmount;
    updatedCalculatedSubTotal = updatedCalculatedSubTotal + shippingCharge;
    let taxAmount = updatedCalculatedSubTotal * ((formData.tax || 0) / 100);
    let grandTotal = updatedCalculatedSubTotal + taxAmount;

    if (formData.exchangeRate) {
      const exchangeRate = formData.exchangeRate;
      calculatedSubTotal /= exchangeRate;
      discountAmount /= exchangeRate;
      taxAmount /= exchangeRate;
      shippingCharge /= exchangeRate;
      grandTotal /= exchangeRate;
    }

    setSubtotal(calculatedSubTotal);
    setCalcDiscount(discountAmount);
    setCalcTax(taxAmount);
    setCalcShipping(shippingCharge);
    setTotal(grandTotal);
  }, [formData, isRetail, serviceType]);

  return { subTotal, total, calcTax, calcDiscount, calcShipping };
};
